import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { AllCategoriesFilterEntity } from '../../domain/entities/AllCategoriesFilterEntity'

export class AllCategoriesFilterModel extends AllCategoriesFilterEntity {
   branchId?: number
  constructor(dataDto: AllCategoriesFilterEntity) {
    super()
    mapEntityProperties<AllCategoriesFilterModel>(this, dataDto, {
      exclude: ['branch'],
      map: {
         branchId: dataDto.branch?.id
      }
    })
  }
}
